import moment from 'moment';
import 'moment/locale/fr-ca';

moment.updateLocale('en-ca', {
  longDateFormat: {
    L: 'YYYY-MM-DD'
  }
});
moment.updateLocale('fr-ca', {
  longDateFormat: {
    L: 'YYYY-MM-DD'
  }
});


// WEBPACK FOOTER //
// ./src/initializeLocales.js